import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import LanguagesList from '../LanguagesList';

const LanguagesPage = () => {
    const classes = useStyles();

    return (
        <>
            <Typography
                variant='h4'
                component='h1'
                className={classes.title}
            >
                Страница управления языками
            </Typography>
            <Divider/>
            <LanguagesList/>
        </>
    )
}

const useStyles = makeStyles(theme => ({
    title: {
        marginTop: 25,
        marginBottom: 25
    }
}))

export default LanguagesPage;
